import axios from 'axios';
import { NO_DATA_FOUND } from 'constants/errorMessage';
import { useInfiniteQuery } from 'react-query';

export const useInfiniteSearch = (url, createBody, queryOptions = {}) => {
  const { pageSize = 10, queryKey, ...infiniteQueryOptions } = queryOptions;
  const getResult = useInfiniteQuery(
    [url, queryKey],
    async ({ pageParam = 1 }) => {
      const response = await axios.request({
        url,
        method: 'POST',
        data: createBody(pageParam),
      });
      const errors = response?.data?.Errors?.filter((it) => it.Message !== NO_DATA_FOUND);
      if (errors?.length > 0) {
        throw errors;
      }

      const rows = response?.data?.Data?.Rows ?? [];
      return {
        data: rows,
        nextPage: pageParam + 1,
        hasMore: rows.length === pageSize,
      };
    },
    {
      getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.nextPage : undefined),
      retry: false,
      ...infiniteQueryOptions,
    }
  );

  return getResult;
};
